import { useSetRecoilState } from 'recoil';

import { acceptedAccessionTermsAtom } from '../atoms/acceptedAccessionTerms';

export default function useSetAccessionsTermsAcceptance() {
  return useSetRecoilState(acceptedAccessionTermsAtom);
}
